<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  import { init } from './scripts/message/index'

  export default {
    name: 'app',
    components: {},
    created() {
      init(this);
    }
  }
</script>

<style lang="scss">
  @import "./assets/scss/base/reset";

  #app {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 960px;
  }
</style>
